import { Link } from "react-router-dom";
import { CONDITIONS } from "../data/site";

export default function ConditionsTreated({ headingTag: Tag = "h2" }) {
  return (
    <section
      id="conditions"
      data-testid="conditions-section"
      className="section-pad border-t border-black/10 bg-[#fbfaf7]"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="overline">Conditions Treated</div>
            <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-[52px] tracking-tight leading-[1.05]">
              Gastro &amp; Liver Conditions Treated in Varanasi.
            </Tag>
            <p className="mt-6 text-black/65 text-[15px] leading-relaxed max-w-md">
              Categorised by organ system, not generic service tiles. Use it
              as a checklist — if it&apos;s on this list, it&apos;s treated here.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {CONDITIONS.map((c, i) => (
              <div
                key={c.category}
                data-testid={`condition-cat-${i}`}
                className="bg-white border border-black/10 rounded-[6px] p-6 md:p-7"
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-display-semibold text-2xl md:text-[26px]">
                    {c.category}
                  </h3>
                  <span className="text-[11px] tracking-[0.18em] uppercase text-black/45 font-semibold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <ul className="mt-5 space-y-3">
                  {c.items.map((it) => {
                    const to = it.slug
                      ? `/diseases/${it.slug}`
                      : it.symptomSlug
                      ? `/symptoms/${it.symptomSlug}`
                      : "/diseases";
                    return (
                      <li
                        key={it.label}
                        className="flex items-center justify-between text-[14.5px] text-black/80 border-b border-dashed border-black/10 pb-2 last:border-0"
                      >
                        <span>{it.label}</span>
                        <Link
                          to={to}
                          className="text-[#0370AD] text-[12px] font-semibold tracking-wide hover:underline"
                        >
                          Read
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
